import React from 'react';
import { DatabaseOutlined } from '@ant-design/icons';

import StorageReportContainer from '@totem/components/administration/storageReporting/StorageReportContainer';
import {
  StorageReportExtra,
  StorageReportLayout,
} from '@totem/components/administration/storageReporting/StorageReportLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import { IBMenuItem } from '@totem/components/ui_components/menus/types';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { UserProfile } from '@totem/types/user';

export const getMenuAdminDataHygiene = (userProfile: UserProfile) => {
  const items: IBMenuItem[] = [
    {
      key: 'storageReporting',
      title: 'Storage Reporting',
      label: 'Storage Reporting',
      description: 'Storage Consumption by Organization and Building',
      route: '/dashboard/admin/storageReporting',
      content: (
        <StorageReportContainer>
          <IBCard
            isCovered
            title="Storage Reporting"
            extra={<StorageReportExtra />}
          >
            <StorageReportLayout />
          </IBCard>
        </StorageReportContainer>
      ),
      icon: <DatabaseOutlined />,
      hasPermissions: () => {
        return permissions.internalSystemAdministrator.hasPermissions(
          userProfile,
        );
      },
    },
  ];

  return items.filter((chk) => chk.hasPermissions(userProfile));
};
